export const CLEARALLCART_MODAL_SHOW = 'CLEARALLCART_MODAL_SHOW';
export const CLEARALLCART_MODAL_HIDE = 'CLEARALLCART_MODAL_HIDE';

export const showClearAllCartModel = ()=>(dispatch) => { 
    dispatch({
        type: CLEARALLCART_MODAL_SHOW,
        payload: {showClearAllcartPop: true}
      });
};

export const hideClearAllCartModel = () => ({
    type: CLEARALLCART_MODAL_HIDE,
    payload: {
        showClearAllcartPop:false
    }
})